const ADD_SUBCLASS = (state, payload) => {
  const aux = {
    subclasse: payload.subclasse,
    classe: payload.classe,
    id: payload.id,
  }

  const subclass = state.lista.find((item) => {
    return item.id === aux.id
  })

  if (subclass) {
    subclass.classe = aux.classe
    subclass.subclasse = aux.subclasse
    subclass.id = aux.id
  } else {
    state.lista.push({ ...aux })
  }

  state.mapper[aux.subclasse] = aux.classe
}

const REMOVE_SUBCLASS = (state, payload) => {
  const aux = {
    subclasse: payload.subclasse,
    classe: payload.classe,
    id: payload.id,
  }

  const subclass = state.lista.find((item) => {
    return item.id === aux.id
  })

  if (subclass) {
    state.lista = state.lista.filter((item) => {
      return item.id !== aux.id
    })
  }

  delete state.mapper[aux.subclasse]
}

const SAVE_LIST = (state, payload) => {
  if (payload) {
    state.lista = JSON.parse(JSON.stringify(payload))
    state.data_atualizacao = new Date()
  }
}

const SAVE_MAPPER = (state, payload) => {
  if (payload) {
    state.mapper = JSON.parse(JSON.stringify(payload))
    state.data_atualizacao = new Date()
  }
}

const SET_LOADING = (state, payload) => {
  state.loading = payload
}

export { ADD_SUBCLASS, SAVE_LIST, SAVE_MAPPER, REMOVE_SUBCLASS, SET_LOADING }
